<template>
    <app-layout>
        <common-content-spacer height="medium">
            <common-page-plain>
                <common-content-spacer height="large">
                    <div class="accordion-section">
                        <!-- Header -->
                        <div class="accordion-header">
                            <div class="users-profile">{{ patientInitials }}</div>
                            <div class="detail-layout">
                                <h4 class="user-name">{{ patientDetails?.firstName }} {{ patientDetails?.lastName }}</h4>
                                <div class="user-date-of-birth">
                                    <common-icon name="timeline" size="tiny"></common-icon>
                                    <span class="date">{{ patientDetails?.dateOfBirth }}</span>
                                    <span class="age">{{ $t('modals.patient.year.title', { age: age }) }}</span>
                                </div>
                            </div>
                            <span class="data">
                                <common-icon name="phone" size="tiny"></common-icon>
                                {{ patientDetails?.mobilePhone }}
                            </span>
                        </div>

                        <!-- Address -->
                        <div class="accordion-bg" :class="{ disabled: !hasAddress }">
                            <div class="adress-layout" @click="toggleSection('address')">
                                <div class="user-date-of-birth">
                                    <common-icon name="location" size="medium" class="location"></common-icon>
                                    <p class="title">{{ $t('modals.patient.address.title') }}</p>
                                </div>
                                <span class="ml-auto">
                                    <template v-if="openSection === 'address'">
                                        <common-icon name="dropdown" size="medium"></common-icon>
                                    </template>
                                    <template v-else><common-icon name="dropdown" size="medium"></common-icon></template>
                                </span>
                            </div>
                            <div v-if="openSection === 'address'" class="adreess-title">
                                {{ patientAddress }}
                            </div>
                        </div>

                        <!-- Insurance -->
                        <div class="accordion-bg" :class="{ disabled: !hasInsurance }">
                            <div class="adress-layout" @click="toggleSection('insurance')">
                                <div class="user-date-of-birth">
                                    <common-icon name="insure" size="medium" class="insure"></common-icon>
                                    <p class="title">{{ $t('modals.patient.insurance.title') }}</p>
                                </div>
                                <span class="ml-auto">
                                    <template v-if="openSection === 'insurance'">
                                        <common-icon name="dropdown" size="medium"></common-icon>
                                    </template>
                                    <template v-else><common-icon name="dropdown" size="medium"></common-icon></template>
                                </span>
                            </div>
                            <div v-if="openSection === 'insurance'" class="adreess-title">
                                <div class="self">
                                    {{ patientInsurancePlan }}
                                </div>
                                <div class="user-date-of-birth">
                                    <div class="group-data">
                                        <p class="inform-titles">
                                            <strong>{{ $t('modals.patient.insurance.group') }}</strong>
                                            <span>{{ patientDetails?.mcard?.groupNumber }}</span>
                                        </p>
                                    </div>
                                    <div class="group-data">
                                        <p class="inform-titles">
                                            <strong>{{ $t('modals.patient.insurance.id') }}</strong>
                                            <span>{{ patientDetails?.mcard?.memberId }}</span>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <!-- Primary Care Provider -->
                        <div class="accordion-bg" :class="{ disabled: !hasProvider }">
                            <div class="adress-layout" @click="toggleSection('provider')">
                                <div class="user-date-of-birth">
                                    <common-icon name="user" size="medium" class="insure-user"></common-icon>
                                    <p class="title">{{ $t('modals.patient.provider.title') }}</p>
                                </div>
                                <span class="ml-auto">
                                    <template v-if="openSection === 'provider'">
                                        <common-icon name="dropdown" size="medium"></common-icon>
                                    </template>
                                    <template v-else><common-icon name="dropdown" size="medium"></common-icon></template>
                                </span>
                            </div>
                            <div v-if="openSection === 'provider'" class="adreess-title">
                                <div class="user-date-of-births">
                                    <div class="provider">{{ providerInitials }}</div>
                                    <div class="title">
                                        {{ patientDetails?.mcard?.primaryCareProvider?.firstName }}
                                        {{ patientDetails?.mcard?.primaryCareProvider?.lastName }}
                                    </div>
                                </div>
                                <div>
                                    <div class="inform-title">
                                        <common-icon name="email" size="tiny"></common-icon>
                                        <a
                                            v-if="patientDetails?.mcard?.primaryCareProvider?.email"
                                            :href="`mailto:${patientDetails?.mcard?.primaryCareProvider?.email}`"
                                            class="text-blue-600"
                                        >
                                            <p class="user-data">{{ patientDetails?.mcard?.primaryCareProvider?.email }}</p>
                                        </a>
                                    </div>
                                    <div class="inform-title">
                                        <common-icon name="phone" size="tiny"></common-icon>
                                        <a
                                            v-if="patientDetails?.mcard?.primaryCareProvider?.phone"
                                            :href="`tel:${patientDetails?.mcard?.primaryCareProvider?.phone}`"
                                            class="text-blue-600"
                                        >
                                            <p class="user-data">{{ patientDetails?.mcard?.primaryCareProvider?.phone }}</p>
                                        </a>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="container">
                        <patient-tab :physician="patientDetails" @toggle="toggleModal"></patient-tab>
                        <patient-tab-content
                            :physician="{
                                MedicalTab: isMedicalTabActive,
                                DetailsTabs: isDetailsTabActive,
                                ProfileTab: isProfileTabActive,
                                SummaryTab: isSummaryTabActive,
                            }"
                            :patientDetails="patientDetails"
                            @toggle="toggleModal"
                        ></patient-tab-content>
                    </div>
                </common-content-spacer>
            </common-page-plain>
        </common-content-spacer>
    </app-layout>
</template>

<script>
    import AppLayout from 'components/layouts/AppLayout'
    import PageWithDataMixin from 'mixins/PageWithDataMixin'
    import PatientTab from 'components/forms/patient/PatientTabs'
    import PatientTabContent from 'components/forms/patient/PatientTabContent'
    import PatientAPI from 'api/PatientAPI'
    import Store from '~/store'

    export default {
        mixins: [PageWithDataMixin],
        components: {
            AppLayout,
            PatientTab,
            PatientTabContent,
        },
        data() {
            return {
                insurancePlans: [],
                patientId: null,
                openSection: null,
                activeTab: 'appointments',
                activeIndex: 0,
                isMedicalTabActive: false,
                isDetailsTabActive: true,
                isProfileTabActive: false,
                isSummaryTabActive: false,
                patientDetails: {},
                isLoading: false,
            }
        },
        computed: {
            patientInitials() {
                if (!this.patientDetails) return ''
                const first = this.patientDetails.firstName?.charAt(0) || ''
                const last = this.patientDetails.lastName?.charAt(0) || ''
                return (first + last).toUpperCase()
            },

            age() {
                if (!this.patientDetails?.dateOfBirth) return ''

                const dob = new Date(this.patientDetails.dateOfBirth)
                const today = new Date()

                let age = today.getFullYear() - dob.getFullYear()
                const month = today.getMonth() - dob.getMonth()

                if (month < 0 || (month === 0 && today.getDate() < dob.getDate())) {
                    age
                }
                return age
            },

            hasAddress() {
                return (
                    this.patientDetails?.address ||
                    this.patientDetails?.city ||
                    this.patientDetails?.state ||
                    this.patientDetails?.zip
                )
            },

            hasInsurance() {
                return (
                    this.patientDetails?.mcard?.primaryInsuranceTypeId ||
                    this.patientDetails?.mcard?.memberId ||
                    this.patientDetails?.mcard?.groupNumber
                )
            },

            hasProvider() {
                return (
                    this.patientDetails?.mcard?.primaryCareProvider?.firstName ||
                    this.patientDetails?.mcard?.primaryCareProvider?.lastName ||
                    this.patientDetails?.mcard?.primaryCareProvider?.email ||
                    this.patientDetails?.mcard?.primaryCareProvider?.phone
                )
            },

            patientAddress() {
                return `${this.patientDetails?.address}, ${this.patientDetails?.city}, ${this.patientDetails?.state}, ${this.patientDetails?.zip}`
            },

            patientInsurancePlan() {
                const id = this.patientDetails?.mcard?.primaryInsuranceTypeId
                if (!id) return ''
                const list = this.insurancePlans
                const item = list.find((x) => x.value === id)
                return item ? item.label : ''
            },

            providerInitials() {
                if (!this.patientDetails) return ''
                const first = this.patientDetails?.mcard?.primaryCareProvider.firstName?.charAt(0) || ''
                const last = this.patientDetails?.mcard?.primaryCareProvider.lastName?.charAt(0) || ''
                return (first + last).toUpperCase()
            },
        },
        methods: {
            toggleModal(name) {
                this.isMedicalTabActive = false
                this.isDetailsTabActive = false
                this.isProfileTabActive = false
                this.isSummaryTabActive = false
                switch (name) {
                    case 'medical':
                        this.isMedicalTabActive = true
                        break
                    case 'details':
                        this.isDetailsTabActive = true
                        break
                    case 'profile':
                        this.isProfileTabActive = true
                        break
                    case 'summary':
                        this.isSummaryTabActive = true
                        break
                }
            },
            toggleSection(section) {
                if (section === 'address' && !this.hasAddress) return
                if (section === 'insurance' && !this.hasInsurance) return
                if (section === 'provider' && !this.hasProvider) return
                this.openSection = this.openSection === section ? null : section
            },
            setActive(i) {
                this.activeIndex = i
            },
            formatDate(iso) {
                const d = new Date(iso)
                return d.toLocaleDateString(undefined, { month: 'short', day: 'numeric', year: 'numeric' })
            },
            formatTime(iso) {
                const d = new Date(iso)
                return d.toLocaleTimeString(undefined, { hour: 'numeric', minute: '2-digit' })
            },
            getPatientDetails() {
                PatientAPI.getPatientDetails(this.patientId, this.$auth.getUser().id)
                    .then((res) => {
                        this.patientDetails = res
                    })
                    .finally(() => {
                        this.isLoading = false
                    })
            },
        },
        mounted() {
            this.insurancePlans = Store.getters['auth/getInsurancePlans']
            this.patientId = this.$route.params.id
            this.getPatientDetails()
        },
    }
</script>

<style scoped lang="scss">
    @import 'styles/components/patients/_patient';
    .user-date-of-births {
        display: flex;
        margin: 10px 1px;
    }
    .user-date-of-birth {
        display: flex;
        align-items: center;
    }
    .tabs-layout {
        gap: 8px;
        background-color: oklch(0.97 0.014 254.604);
        padding: 4px;
        border-radius: 8px;
        box-shadow: 0 2px 6px rgba(0, 0, 0, 0.1);
    }
    .title {
        margin-left: 12px;
    }
    i.location {
        color: oklch(0.546 0.245 262.881);
    }
    i.insure {
        color: oklch(0.627 0.194 149.214);
    }
    i.insure-user {
        color: oklch(0.558 0.288 302.321);
    }
    .user-data {
        margin-left: 12px;
    }
    .inform-titles strong {
        font-size: 10px !important;
    }
    .inform-titles span {
        font-size: 10px !important;
        margin-left: 10px;
    }
    .inform-title {
        display: flex;
        align-items: center;
        margin: 9px 11px !important;
        color: oklch(0.446 0.03 256.802);
        font-size: 12px;
    }
    .self {
        color: oklch(0.21 0.034 264.665);
        font-size: 13px;
        font-weight: 500;
    }
    p.patient-profile-sidebar {
        flex: 1;
        padding: 8px 16px !important;
        border: none;
        border-radius: 6px;
        background-color: transparent;
        cursor: pointer;
        font-size: 12px;
        font-weight: 500;
        transition: background-color 0.2s;
        text-align: center;
        color: oklch(0.145 0 0);
    }

    .data {
        font-size: 12px;
    }
    .patient-profile-sidebar.active {
        background-color: #2563eb;
        color: #fff;
        text-align: center;
        font-size: 12px;
        font-weight: 500;
    }
    .tab-content {
        margin-top: 24px;
    }
    .subtitle {
        color: #666;
        margin-bottom: 16px;
    }
    .age {
        background-color: #ececf0;
        padding: 3px 6px;
        border-radius: 6px;
        margin: 2px 10px;
        color: #030213;
        font-size: 10px;
    }
    .date {
        color: oklch(0.446 0.03 256.802);
        font-size: 12px;
    }
    .provider {
        background-color: oklch(0.627 0.265 303.9);
        width: 32px;
        height: 32px;
        border-radius: 30px;
        color: #fff;
        display: flex;
        justify-content: center;
        align-items: center;
        font-size: 12px;
    }
    .group-data {
        width: 700px;
    }
    .adreess-title {
        padding: 0px 0px 0px 33px;
        color: oklch(0.373 0.034 259.733);
        font-size: 12px;
        margin: 9px 0px;
    }
    .accordion-bg {
        background-color: oklch(0.985 0.002 247.839);
        padding: 10px 20px;
        border-radius: 10px;
        margin: 10px 0px;
    }
    .adress-layout {
        display: flex;
        align-items: center;
        justify-content: space-between;
        width: '100%';
    }
    .title {
        color: oklch(0.21 0.034 264.665);
        font-size: 13px;
        font-weight: 500;
    }
    .titles {
        color: oklch(0.145 0 0);
        font-size: 16px !important;
        font-weight: 500;
    }
    .detail-layout {
        margin-left: 15px;
    }
    .user-name {
        color: oklch(0.21 0.034 264.665);
        font-weight: 500;
        font-size: 16px;
    }
    .users-profile {
        background: oklch(0.932 0.032 255.585);
        padding: 12px;
        width: 70px;
        height: 70px;
        border-radius: 50px;
        align-items: center;
        color: oklch(0.546 0.245 262.881);
        font-weight: 600;
        font-size: 16px;
        display: flex;
        justify-content: center;
    }
    .accordion-header {
        display: flex;
        align-items: center;
    }
    .accordion-section {
        background-color: #fff;
        padding: 0px;
        border-radius: 10px;
    }
    .disabled {
        opacity: 0.4;
    }
</style>
